import { flagColorMap } from "features/shared/data"
export const flaggedLeadDetailsTransformer = response => {
  const item = response?.[0]
  if (!item) return null
  const flagKey = item?.InternalInquiryCategory?.key
  return {
    ...item,
    flagColor: flagColorMap[flagKey]?.flagColor,
    bgColor: flagColorMap[flagKey]?.bgColor,
    icon: flagColorMap[flagKey]?.icon,
  }
}
